export var TaskTypes = [
    'invalidate',
    'manualLoad',
    'load',
    'purge',
    'subscribe',
];
export var DefaultRequestPolicies = {
    loadInvalidated: 0,
    loadOnce: 0,
    subscribe: 0,
};
export var InitialPointerState = {
    modifiers: {
        keep: 0,
        pause: 0,
        pending: 0,
    },
    request: null,
    tasks: {
        manualLoad: null,
        invalidate: null,
        load: null,
        purge: null,
        subscribe: null,
    },
    value: null,
};
//# sourceMappingURL=constants.js.map